// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_gN","advertCardHeader__actions":"c-a_gO","advertCardHeader__bottomLabel":"c-a_gP"};